import type { FaireProductEntity } from "../../entity_types/product";

export const p_6jbvquftkm: FaireProductEntity = {
  token: "p_6jbvquftkm",
  type: "product",
  name: "Kids Relief Throat Ease Syrup for Kids 0-12 Years, 3.4 oz",
  brandToken: "b_7btl61xote",
  brandName: "homeolab International Inc",
  imageUrl:
    "https://cdn.faire.com/fastly/ab643cda02a877de0f14f34dabbef126a4a9d3c65cecee36795811044471d834.png",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/ab0cedf54b83b04882d63559af3357216d72c7278ff70e5419b6b8c655dff80a.jpeg",
    "https://cdn.faire.com/fastly/be41c3591da7e631a418fd0b1a68ebb115ed2492613427b2ea136070cab80e61.jpeg",
    "https://cdn.faire.com/fastly/7cad98be8644860cb5e6507954d552cdcfddc1bc900cf8ec829402e8404880dd.jpeg",
    "https://cdn.faire.com/fastly/dda6d4ec1e83b76494f1d3db2af58aeef2e29ddc0442eba350b88d59addec461.png",
    "https://cdn.faire.com/fastly/cd2df3c0c6ef5fd1754eeee78f04bdec494a305dd82e564ec8043b42e7079a9c.jpeg",
    "https://cdn.faire.com/fastly/6d8bc834bdd6c75beb5182c36fd476e1c905585e303717566f87d1dd991d0f43.jpeg",
  ],
  priceDollars: 8.3,
  description:
    "No matter how old you are, a sore throat is never fun. Bring the fun back into your child’s life when you take the sick away with Kids Relief Throat Ease. Watch as your child’s sore throat disappears. Kids Relief Throat Ease is a great-tasting syrup that is safe for kids with no risk of side effects, drug interaction or overdose.\n\nSafe: Our Throat Ease syrup is sealed with a child proof cap. There are no Side Effects, (No drug interactions), Gluten free, Dye free and Sugar free.\n\nThis homeopathic medicine helps relieve symptoms associated with a sore throat: Burning pain, Inflammation, Difficulty to swallow, Hoarseness, Irritation.\n\nOur Throat Ease syrup comes in a great tasting caramel flavor. It offers up to 20-40 individual doses per bottle depending on your child's age. They are easy to measure with the measuring cup included in the box.\n",
  tags: [],
  msrpDollars: 13.84,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-03-26T23:55:25.327Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
